import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@olxbr/ds-web';
import { Container } from './styles';
import YouTubePlayer from './YoutubePlayer';
import { RedirectButtons } from '../RedirectButtons';
export function YoutubeCard(_ref) {
  var getStyledText = _ref.getStyledText,
    content = _ref.content,
    idPage = _ref.idPage;
  return /*#__PURE__*/React.createElement(Container, {
    type: "outlined",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(YouTubePlayer, {
    idYoutube: content.idYoutube
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    margin: "--spacing-2",
    flexDirection: "column"
  }, getStyledText("title", content.title, content === null || content === void 0 ? void 0 : content.badgeText, content === null || content === void 0 ? void 0 : content.badgeColor), getStyledText("description", content.description)), content.redirectLink && /*#__PURE__*/React.createElement(RedirectButtons, {
    content: content,
    idPage: idPage
  }));
}
YoutubeCard.propTypes = {
  idPage: PropTypes.string.isRequired,
  getStyledText: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired
};
export default YoutubeCard;